import { useEffect, useState } from 'react';
import { getAllLessonPlans } from '../../services/LessonPlansService';
import { Link } from 'react-router-dom';

export default function LessonPlansPage() {
  const [lessonPlans, setLessonPlans] = useState([]);

  useEffect(() => {
    async function loadPlans() {
      const plans = await getAllLessonPlans();
      setLessonPlans(plans);
    }
    loadPlans();
  }, []);

  return (
    <div>
      <h1>Available Lesson Plans</h1>
      <ul>
        {lessonPlans.map(plan => (
          <li key={plan.id}>
            <Link 
              to={`/lesson-plans/${plan.id}`} 
              state={{ lessonPlanName: plan.name }}  // ✅ Pass name via `state`
            >
              {plan.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
